import { Inject, Injectable } from '@angular/core';
import { ErrorHandlerService } from '@y42/error-handling';
import { getY42GitPath, Y42GitFolders } from '@y42/feature/git';
import { AbstractGitService, GitParentFolders, GIT_PARENT_FOLDERS } from '@y42/feature/git/state';
import { Y42MetadataGitModel } from '@y42/feature/json-schema';
import { GitQuery, GitService } from '@y42/git';
import { ExportTriggerSettingsGitModel, ExportTriggerStoreModel } from './export-trigger.model';

@Injectable({ providedIn: 'root' })
export class ExportTriggerGitService extends AbstractGitService<ExportTriggerStoreModel, Y42GitFolders.Export> {
  constructor(
    protected readonly git: GitService,
    protected readonly gitQuery: GitQuery,
    protected readonly errorHandlerService: ErrorHandlerService,
    @Inject(GIT_PARENT_FOLDERS) protected readonly parentFolders: GitParentFolders,
  ) {
    super({
      gitQuery,
      git,
      name: `Export-Trigger-Git`,
      basePath: getY42GitPath(Y42GitFolders.Export),
      parentFolders,
      errorHandlerService,
      models: {
        metadata: {
          fileName: 'metadata.json',
          model: Y42MetadataGitModel,
        },
        settings: {
          fileName: 'settings.json',
          model: ExportTriggerSettingsGitModel,
        },
      },
    });
  }
}
